/**
 * URI de redirection OAuth : doit correspondre EXACTEMENT à une URI
 * enregistrée pour le client_id sur le serveur OAuth (accounts / devaccounts).
 *
 * En local (localhost / 127.0.0.1), on utilise toujours l'origine courante + /login.
 * En prod, l'URI doit être identique à celle enregistrée sur accounts.netikash.com
 * (ex. https://flow.netikash.com/login — pas seulement le domaine racine).
 */
export function resolveOAuthRedirectUri() {
    const { protocol, host, hostname } = window.location;
    const isLocal =
        hostname === 'localhost' ||
        hostname === '127.0.0.1' ||
        hostname === '[::1]';

    if (isLocal) {
        return `${protocol}//${host}/login`;
    }

    const fromEnv = process.env.REACT_APP_OAUTH_REDIRECT_URI;
    if (fromEnv && String(fromEnv).trim()) {
        return String(fromEnv).trim();
    }

    return `${protocol}//${host}/login`;
}
